import React from 'react'

import Typography from '../../../../../UniformComponents/Typography'

const AiOverview = () => (process.env.SHOW_AI_ASSISTANT
    ? (
        <div id="aiOverview">
            <div className="container">
                <div className="icon-container">
                    <i className="fas fa-sparkles" />
                </div>

                <Typography>
                    Lorem ipsum dolor sit amet consectetur adipiscing elit. Sit amet consectetur adipiscing elit quisque faucibus ex. Adipiscing elit quisque faucibus ex sapien vitae pellentesque.
                </Typography>
            </div>
        </div>
    ) : null)

export default AiOverview
